export const utilityBarConsts = {
  SEARCH_FIELD_NAME: "searchField",
  SEARCH_PLACEHOLDER: "Search",
  SEARCH_ICON_ALT: "Click to search",
  SYNC_FROM_QUICKBOOKS: "Sync from QuickBooks",
  ADD_QUARRY_BTN: "+ Add Quarry",
};
